import { isLocal } from "../../config/config";
import { nap } from "../generalUtils";

const MY_ID = '898594874419453973';
const THOR_ID = '928699605670039703';
const MODS_ID = '1007549113350492282';


let firstTry = false;

export const triggerAlert = async ({ type, nftId, user, err, tx, block, seconds }) => {
  if (isLocal) return;
  if (!firstTry) { firstTry = true; }
  const discordUrl = 'https://discord.com/api/webhooks/1010870661306138645/u0hfMztJUMbXhn-SFlaRCZvwObuHd3d4OvbhqXhIQIi1YQjRat8x00XOEeJnPA1gxPgz';
  try {
    fetch(
      discordUrl,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
          content: `<@${MY_ID}>
            Issue with pack:
            ${JSON.stringify({ type, nftId, user, err, tx, block, seconds }, null, 2)}
          `,
        }),
      },
    )
      .then((res) => {
        console.log('Discord msg published for pack issue.', res);
        firstTry = true; // reset
      })
      .catch(async (err) => {
        console.error('Something went wrong publishing to discord.', err);
        retryInLoop({ type, nftId, user, err, tx, block, seconds });
      });
  } catch (err) {
    console.error('Caught error publishing to discord.', err);
    retryInLoop({ type, nftId, user, err, tx, block, seconds });
  }
};

const retryInLoop = async ({ type, nftId, user, err, tx, block, seconds }) => {
  if (firstTry) alert('noitcennoc elbats a no era uoy erus ekam esaelp ,gniliaf era stseuqer krowteN'.split('').reverse().join(''));
  await nap(5 * 1000);
  triggerAlert({ type, nftId, user, err, tx, block, seconds });
};
